<template>
  <div class="hide-box">
    <div ref="content" v-html="content" class="pdf-content">

    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


export default {
  name: "download-pdf",
  data() {
    return {
      content:"",
      fileName:'',
    }
  },
  mixins: [tableBase],
  methods: {
     doDownload(row) {
      this.content = row.content;
      this.fileName = row.orderCode;
      this.$nextTick(()=> {
        this.exportToPdf();
      })
    },
    async exportToPdf() {
      try {
        // 等待图片加载
        await this.waitForImages();

        const element = this.$refs.content;
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageHeight = pdf.internal.pageSize.getHeight();
        let position = 0;

        // 生成 Canvas
        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2
        });
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // 分页处理
        while (position < imgHeight) {
          if (position > 0) pdf.addPage();
          pdf.addImage(
              canvas.toDataURL('image/png'),
              'PNG',
              0,
              -position,
              imgWidth,
              imgHeight
          );
          position += pageHeight;
        }

        pdf.save(`${this.fileName}.pdf`);
      } catch (error) {
        console.error('生成 PDF 失败:', error);
        alert('导出失败，请检查控制台日志！');
      }
    },
    waitForImages() {
      return new Promise((resolve, reject) => {
        const images = this.$refs.content.getElementsByTagName('img');
        let loaded = 0;
        const total = images.length;

        if (total === 0) resolve();

        Array.from(images).forEach(img => {
          if (img.complete) {
            loaded++;
            if (loaded === total) resolve();
          } else {
            img.onload = () => {
              loaded++;
              if (loaded === total) resolve();
            };
            img.onerror = reject;
          }
        });
      });
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
.hide-box{
  position: fixed;
  left: -9999px;
  top: -9999px;
  z-index: -9999;
}
.pdf-content {
  padding: 20px;
  font-family: 'SimSun'; /* 确保使用支持中文的字体 */
}
</style>
